import Udesk from 'Udesk';

function getServerAuthorization({
    type
}) {
    if (!type) {
        type = 4;
    }
    return new Promise(function (resolve, reject) {
        Udesk.ajax.get(`/backend/oss/tokens/${type}`).then(
            function (resp, textStatus, jqXHR) {
                resolve(resp);
            },
            function (reason) {
                reject(reason);
            });
    });
}

export {
    getServerAuthorization
};